import React from "react";
import { Link } from "react-router-dom";

const GoldButton = ({ text, link, inNewTab, isGrey }) => {
    const buttonContent = (
        <div className={`gold-button${isGrey ? " grey-button" : ""}`}>
            <p>{text && text}</p>
            <p><i className="fas fa-chevron-right"></i></p>
        </div>
    );

    const LinkContent = ({children}) => {
        return inNewTab ? (
            <Link to={link} target="_blank" rel="noreferrer">{children}</Link>
        ) : (
            <Link to={link}>{children}</Link>
        );
    }

    return link ? <LinkContent>{buttonContent}</LinkContent> : buttonContent;
}

export default GoldButton;